export default (errors, name) =>
  Object.keys(errors).reduce((prev, current) => {
    if (name === current) return { ...prev };
    return { ...prev, [current]: errors[current] };
  }, {});
